class ToggleMore extends HTMLElement {
  connectedCallback() {
    this.holder = this.querySelector('[data-holder]');
    this.content = this.querySelector('[data-content]');
    this.button = this.querySelector('[data-button]');

    this.checkTogglable();
    window.addEventListener('resize', this.checkTogglable.bind(this));
    this.button.addEventListener('click', () => {
      this.toggleToggleMore();
    });
  }

  // Check if the element should have a read more button
  checkTogglable() {
    // Preserve the current state (open or not)
    const isOpen = this.classList.contains('open');
    this.classList.remove('open');
    this.classList.remove('no-button');

    // Check the height of the content compared to holder height
    if (this.content.offsetHeight > this.holder.offsetHeight) {
      this.classList.remove('no-button');
    } else {
      this.classList.add('no-button');
    }

    if (isOpen) {
      this.classList.add('open');
    }
  }

  toggleToggleMore() {
    this.classList.toggle('open');
  }
}

customElements.define('toggle-more', ToggleMore);
